import journeyService from '@/services/journeyService'
import { FAVORITE_SET, FAVORITE_UNSET } from './mutations'

/**
 * Actualiza el favorito de un ítem con actualización optimista y rollback automático.
 *
 * La clave del store usa `slug` (estable entre llamadas a la API).
 * El `contentId` encriptado se usa SOLO para el POST al backend.
 *
 * @param {object} params
 * @param {string} params.contentType  Tipo de contenido ('podcast', 'challenge', etc.)
 * @param {string} params.slug         Slug estable del contenido (clave del store)
 * @param {string} params.contentId    ID encriptado del contenido (para la API)
 * @param {boolean} params.value       Nuevo estado deseado (true = marcar, false = desmarcar)
 */
export async function setFavorite({ commit, state }, { contentType, slug, contentId, value }) {
  const key         = `${contentType}:${slug}`
  const hadPrevious = Object.prototype.hasOwnProperty.call(state.favorites, key)
  const previous    = state.favorites[key]

  // Actualización optimista — el usuario ve el cambio de inmediato.
  commit(FAVORITE_SET, { contentType, slug, value })

  try {
    await journeyService.toggleFavorite(contentType, contentId, value)
  } catch (ex) {
    // Rollback: restaurar estado anterior o eliminar si nunca existió localmente.
    if (hadPrevious) {
      commit(FAVORITE_SET, { contentType, slug, value: previous })
    } else {
      commit(FAVORITE_UNSET, { contentType, slug })
    }
    console.error('[dailyMeditation/setFavorite]', ex)
  }
}
